function getTotalNavHeight() {
  let navHeight = document.querySelector(".navigation-wrapper").clientHeight;
  let faqNavHeight = document.querySelector(
    ".product-comparison-table__header"
  ).clientHeight;
  let totalNavHeight = navHeight + faqNavHeight;

  return [navHeight, totalNavHeight];
}

function setStickyPosition() {
  let totalNavHeight = getTotalNavHeight();
  document.querySelector(".product-comparison-table__header").style.top = `${
    totalNavHeight[0] - 2
  }px`;
}

let totalNavHeight = getTotalNavHeight();
window.addEventListener("resize", (event) => setStickyPosition());
window.addEventListener("DOMContentLoaded", (event) => setStickyPosition());

function changeProduct(el, id) {
  const info = el.split("|");
  const productData = allProducts.find((product) => product.handle == info[3]);
  const target = document.querySelector(`product-info[column_id='${id}'`);

  if (target) {
    target.setAttribute("name", info[0]);
    target.setAttribute("image", info[1]);
    target.setAttribute("url", info[2]);
  }

  setProductData(id, productData);
}


function setProductData(id, productData) {
  const generalFeatures = document.querySelectorAll(
    `[data-column-type='general-features'][data-column-id='${id}'] td`
  );
  const functionalFeatures = document.querySelectorAll(
    `[data-column-type='functional-features'][data-column-id='${id}'] td`
  );
  const safetyFeatures = document.querySelectorAll(
    `[data-column-type='safety-features'][data-column-id='${id}'] td`
  );
  const specs = document.querySelectorAll(
    `[data-column-type='specs'][data-column-id='${id}'] td`
  );

  generalFeatures.forEach((feature) => {
    const featureName = feature.getAttribute("feature-type");
    const featureValue = productData.generalFeatures[`${featureName}`];
    console.log("featureValue",featureValue);
    if (featureName == "seatCapacity") {
      feature
        .querySelector("[data-seat-capacity-icon-wrapper]")
        .setAttribute("value", `_${featureValue}`);
    } else {
      feature.querySelector("span").setAttribute("value", featureValue);
    }
  });

  functionalFeatures.forEach((feature) => {
    const featureName = feature.getAttribute("feature-type");
    const featureValue = productData.functionalFeatures[`${featureName}`];
    feature.querySelector("span").setAttribute("value", featureValue);
  });

  safetyFeatures.forEach((feature) => {
    const featureName = feature.getAttribute("feature-type");
    const featureValue = productData.safetyFeatures[`${featureName}`];
    feature.querySelector("span").setAttribute("value", featureValue);
  });

  specs.forEach((feature) => {
    const featureName = feature.getAttribute("feature-type");
    const featureValue = productData.specs[`${featureName}`];
    feature.querySelector("span em").innerHTML = featureValue;
  });
}

const productSelectors = document.querySelectorAll("select");
productSelectors.forEach((selector) => {
  changeProduct(selector.value, selector.dataset.tableColumnControls);
  selector.addEventListener("change", function () {
    changeProduct(selector.value, selector.dataset.tableColumnControls);
  });
});

const template = document.createElement("template");

class ProductInfo extends HTMLElement {
  static get observedAttributes() {
    return ["name", "image", "url"];
  }
  constructor() {
    super();
    let template = document.getElementById("productInfo");
    let templateContent = template.content;

    this.attachShadow({ mode: "open" });
    this.shadowRoot.append(templateContent.cloneNode(true));
    this.shadowRoot.querySelector("p").innerText = this.getAttribute("name");
    this.shadowRoot
      .querySelector("img")
      .setAttribute("src", this.getAttribute("image"));
    this.shadowRoot
      .querySelector("a")
      .setAttribute("href", this.getAttribute("url"));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue !== oldValue) {
      switch (name) {
        case "name":
          this.shadowRoot.querySelector("p").innerText = newValue;
          break;
        case "image":
          this.shadowRoot.querySelector("img").setAttribute("src", newValue);
          break;
        case "url":
          this.shadowRoot.querySelector("a").setAttribute("href", newValue);
          break;
      }
    }
  }
}

customElements.define("product-info", ProductInfo);
